import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormAndClinicHeader from '../../components/Setting/FormAndClinicHeader';
import ClinicForm from '../../components/Setting/ManageClinics/ClinicForm';
import ClinicRow from '../../components/Setting/ManageClinics/ClinicRow';
import { MainDialog } from '../../components/UI';
import MessagesContext from '../../contexts/messagesContext';
import { getClinics } from '../../redux/Clinic/ClinicAction';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Clinic/ClinicType';

const styles = makeStyles({
    container: {
        // paddingTop: '24px'
    },
    title: {
        borderBottom: 'solid 1px rgba(206, 210, 214, 0.8)',
        padding: '16px 0',
        '& span': {
            fontWeigh: 'bold'
        }
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
    loadingContainer: {
        height: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
});
const ManageClinics = () => {
    const classes = styles();
    const clinics = useSelector((state) => state.clinic.clinics);
    const dispatch = useDispatch();
    const { messages } = useContext(MessagesContext);
    const [dialog, setDialog] = useState(false);
    const loadingSelector = createLoadingSelector(type.GET_CLINICS.REQUEST);
    const isLoading = useSelector(loadingSelector);

    useEffect(() => {
        dispatch(getClinics());
    }, []);

    return (
        <div className={'container'}>
            <MainDialog
                open={dialog}
                title={messages.newClinic}
                goBack={() => setDialog(false)}
                minHeight="300"
            >
                <ClinicForm handleClose={() => setDialog(false)} />
            </MainDialog>
            <FormAndClinicHeader
                title={messages.permissionsTitle.manage_clinic}
                buttonText={messages.newClinic}
                handleClick={() => setDialog(true)}
            />
            <div className={classes.container}>
                {isLoading && (clinics === null || clinics === undefined) ? (
                    <div className={classes.loadingContainer}>
                        <CircularProgress />
                    </div>
                ) : !clinics?.length || clinics === null || clinics === undefined ? (
                    <div className={classes.loadingContainer}>
                        <span>{messages.noClinicFound}</span>
                    </div>
                ) : (
                    <>
                        <div className={classes.title}>
                            <span>{messages.clinicName}</span>
                        </div>
                        <div className={classes.column}>
                            {clinics?.map((item) => (
                                <ClinicRow key={item.id} item={item} />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ManageClinics;
